<template>
  <small class="app-legend-description">
    <slot />
  </small>
</template>

<script>
export default {
  name: 'AppLegendDescription',
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';
@import '@/styles/functions.scss';

.app-legend-description {
  display: block;
  color: rgba(0, 0, 0, 0.5);
  margin: -0.75em 0 0.75em;
}
</style>
